/**
 * Suspense fallback for pro routes: a full screen of page background (with
 * the profile cover band), so the footer never sits in view and then jumps
 * away when the page arrives — that jump was most of the CLS.
 */
export function ProFallback() {
  return (
    <div className="pro-root min-h-[110dvh]" role="status" aria-live="polite">
      <div className="h-36 bg-gradient-to-br from-[#1e3a8a] via-[#3730a3] to-[#6d28d9] opacity-90 sm:h-52 lg:h-60" />
      <span className="sr-only">…</span>
    </div>
  );
}

/** Fallback for sections inside the cabinet shell (no cover band). */
export function CabinetFallback() {
  return (
    <div className="flex min-h-[60vh] flex-col gap-3" role="status" aria-live="polite">
      <div className="p-shimmer h-8 w-56 rounded-xl" />
      <div className="p-shimmer h-40 rounded-2xl" />
      <div className="p-shimmer h-40 rounded-2xl" />
    </div>
  );
}
